import ScrollMagic from 'scrollmagic';
import Controller from '@/scripts/utils/scrollmagic/controller';
import selectors from '@/scripts/animation/animation-selectors';
import _debounce from 'lodash/debounce';
import createEvent from '@/scripts/utils/create-event';
import { TweenMax } from 'gsap/TweenMax';
import './parallax-img.scss';

document.addEventListener('DOMContentLoaded', () => {
  const images = document.querySelectorAll(selectors.parallaxImageContainer);
  const namespace = 'parallax-image';
  images.forEach((container) => {
    const { addSides } = container.dataset;
    const { parallaxDistance, parallaxItem } = selectors;
    const $container = $(container);
    const img = container.querySelector(parallaxItem);
    let sides = [];
    container.classList.add(namespace);
    img.classList.add(`${namespace}__item`);

    let scrollProgress = 0;
    const sidesTransform = {
      scaleX: 0,
    };
    const imageTransform = {
      translateY: 0,
    };

    TweenMax.ticker.addEventListener('tick', () => {
      if (scrollProgress > 0 && scrollProgress < 1) {
        imageTransform.translateY += (scrollProgress * parallaxDistance - imageTransform.translateY) * 0.05;
        imageTransform.translateY = Math.abs(imageTransform.translateY - scrollProgress * parallaxDistance) < 0.5
          ? scrollProgress * parallaxDistance
          : imageTransform.translateY;
        $(img).css({
          transform: `translateY(${imageTransform.translateY}px)`,
        });
        if (addSides) {
          sidesTransform.scaleX += (scrollProgress - sidesTransform.scaleX) * 0.05;
          sidesTransform.scaleX = Math.abs(sidesTransform.scaleX - scrollProgress) < 0.05
            ? scrollProgress : sidesTransform.scaleX;
          $(sides).css({
            transform: `scaleX(${sidesTransform.scaleX})`,
          });
        }
      }
    });

    if (addSides) {
      sides = [$(`<span class="${namespace}__left-side"></span>`), $(`<span class="${namespace}__right-side"></span>`)];
      $container.append(sides);
    }

    let containerHeight;
    function resize() {
      containerHeight = $(container).height() || $(container).width() * 0.5625; // responsive image

      $(img).css({
        height: containerHeight + parallaxDistance,
      });

      img.dispatchEvent(createEvent('resize'));
    }

    resize();
    window.addEventListener('resize', _debounce(resize, 100));

    return new ScrollMagic.Scene({
      triggerElement: container,
      triggerHook: 'onEnter',
      offset: -80,
      duration: containerHeight + $(window).height(),
    })
      .on('progress', (e) => {
        scrollProgress = e.progress;
      })
      .addTo(Controller);
  });
});



// WEBPACK FOOTER //
// ./scripts/utils/scrollmagic/scenes/parallax-img/parallax-img.js